import { render, staticRenderFns } from "./CategorySubChildFilters.vue?vue&type=template&id=add948c8&scoped=true&"
import script from "./CategorySubChildFilters.vue?vue&type=script&lang=ts&"
export * from "./CategorySubChildFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CategorySubChildFilters.vue?vue&type=style&index=0&id=add948c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add948c8",
  null
  
)

export default component.exports